exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".hextech-slotOuter-1P5OM{fill:#010A13;fill-opacity:0.5}.hextech-slotInner-2cHSA{fill:none;stroke:#362D1B;stroke-miterlimit:10}.hextech-slotMiddle-BQ9wL{fill:none;stroke:#6B5024;stroke-width:3;stroke-miterlimit:10}.hextech-st3-2zNv8{fill:none;stroke:#6B5024;stroke-miterlimit:10}\n", ""]);

// Exports
exports.locals = {
	"slotOuter": "hextech-slotOuter-1P5OM",
	"slotInner": "hextech-slotInner-2cHSA",
	"slotMiddle": "hextech-slotMiddle-BQ9wL",
	"st3": "hextech-st3-2zNv8"
};